import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Children, memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
const NavigationalPillGroup = ({ children, horizontalPadding = 0, title, }) => {
    const navigationalPillGroupStyles = useMemo(() => (css `
        ${styleUtils.visibleScrollbarStyles}
        column-gap: ${theme.spacing.x4};
        display: flex;
        list-style: none;
        overflow-x: auto;
        padding-bottom: ${theme.spacing.x2};
        padding-left: ${styleUtils.rem(horizontalPadding)};
        padding-right: ${styleUtils.rem(horizontalPadding)};
        padding-top: 0;
        margin-bottom: 0;
        margin-left: 0;
        margin-right: 0;
        margin-top: 0;

        @media (pointer: coarse) and (max-width: ${theme.breakpoints.small}) {
          ${styleUtils.hiddenScrollbarStyles}
        }
      `), [
        horizontalPadding,
    ]);
    const titleStyles = useMemo(() => (css `
        ${theme.typeStyles.captionLargeStyles}
        margin-bottom: ${theme.spacing.x6};
        margin-left: ${styleUtils.rem(horizontalPadding)};
        margin-right: ${styleUtils.rem(horizontalPadding)};
        margin-top: 0;
      `), [
        horizontalPadding,
    ]);
    return (_jsxs("nav", { children: [title
                && (_jsx("div", Object.assign({ css: titleStyles }, { children: title }))), _jsx("ul", Object.assign({ css: navigationalPillGroupStyles }, { children: Children
                    .map(children, (child, index) => (_jsx("li", { children: child }, index))) }))] }));
};
const MemoizedNavigationalPillGroup = memo(NavigationalPillGroup);
export { MemoizedNavigationalPillGroup as NavigationalPillGroup };
// MC-1068 Temporary hack for Storybook.
export default MemoizedNavigationalPillGroup;
